<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>PROFILE.CHANGE_PASSWORD</div>

</ion-header>

<ion-content class="ion-padding page2" no-bounce>

  <ion-list>
    <ion-item>
      <ion-label color="dark" position="stacked">
        <div translate>PROFILE.OLD_PASSWORD</div>
      </ion-label>
      <ion-input [placeholder]="'PROFILE.OLD_PASSWORD_PLACEHOLDER' | translate" [type]="showPassword ? 'text' : 'password'"  [(ngModel)]="oldPassword"></ion-input>
    </ion-item>

    <ion-item>
      <ion-label color="dark" position="stacked">
        <div translate>PROFILE.NEW_PASSWORD</div>
      </ion-label>
      <ion-input [placeholder]="'PROFILE.NEW_PASSWORD_PLACEHOLDER' | translate" [type]="showPassword ? 'text' : 'password'" [(ngModel)]="newPassword"></ion-input>
    </ion-item>

    <ion-item>
      <ion-label color="dark" position="stacked">
        <div translate>PROFILE.REPEAT_NEW_PASSWORD</div>
      </ion-label>
      <ion-input [placeholder]="'PROFILE.REPEAT_NEW_PASSWORD_PLACEHOLDER' | translate" [type]="showPassword ? 'text' : 'password'" [(ngModel)]="newPasswordRepeat"></ion-input>
    </ion-item>

    <ion-item>
      <ion-label color="dark">
        <div translate>PROFILE.SHOW_PASSWORD</div>
      </ion-label>
      <ion-checkbox slot="start" color="dark" [(checked)]="showPassword" (ionChange)="showPassword = !showPassword"></ion-checkbox>
    </ion-item>
  </ion-list>

</ion-content>

<ion-footer class="ion-padding page2">
  <ion-button fill="solid" shape="round" expand="block" color="light" class="full-width" (click)="onChangeClick()" [disabled]="!isValid"><div translate>PROFILE.CHANGE</div></ion-button>
</ion-footer>
